import {
    IRef,
} from './types';

import {
    useDefaultedRef,
} from 'tools/hooks';

export function useMediasInputRef() {
    return useDefaultedRef<IRef>({
        getValue(): string[] {
            return [];
        },
        validate(): boolean {
            return true;
        },
    });
}
